import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RecordProfileVisitResponse extends BackendResponse {}

export interface RecordProfileVisitParameters extends NextApiParams {
  concernId: number;
  candidateId: number;
}

export const recordProfileVisit = withNextApi<
  RecordProfileVisitResponse,
  RecordProfileVisitParameters
>("/metadata/RecordProfileVisit", { method: "POST" });
